export const setLoading = ((loading) => {
  return {type: 'SET_LOADING', loading};
});



// WEBPACK FOOTER //
// ./src/containers/App/Reducers/actions.js